<div>
  <form (submit)="onSubmit()" [formGroup]="form" class="transfer-form">
    <mat-dialog-content>
      <mat-error *ngIf="errors$ && errors$.is_esdp" class="mb-3">
        {{ errors$.is_esdp[0] }}
      </mat-error>
      <app-date-picker
        formControlName="period_start_date"
        label="Дата начала обучения"
        hint="ДД.ММ.ГГГГ"
        [appearance]="'outline'"
        [formGroup]="form"
        [control]="period_start_date"
        [datePicker]="period_start_date"
        [prevDateDisabledKey]="true"
        [errorFromApi]="
          errors$ && errors$.period_start_date
            ? errors$.period_start_date[0]
            : null
        "
        [requiredErrorMessage]="'Обязательное поле'"></app-date-picker>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Дни занятий</mat-label>
        <mat-select
          formControlName="lesson_days"
          [panelClass]="UIThemeService.purpleDarkThemeFieldPanel() | async">
          <mat-option *ngFor="let day of days | keyvalue" [value]="day.key">
            {{ day.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="errors$ && errors$.lesson_days" class="mb-3">
          {{ errors$.lesson_days[0] }}
        </mat-error>
        <mat-error *ngIf="lesson_days?.errors?.required">
          Обязательное поле
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        [loading$]="loading$ | async"
        [isDisabled]="(loading$ | async) || form.invalid"
        label="Перевести"></app-button-with-progress>
    </div>
  </form>
</div>
